export default "__VITE_ASSET__FQQCcSzu__"